import { getAuth, checkActionCode, applyActionCode, sendPasswordResetEmail } from 'firebase/auth';
import { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SiteType } from './App';

const RecoverEmail = () => {
    const { isPcSite } = useContext(SiteType);
    const { t } = useTranslation();
    const [initCheck, setInitCheck] = useState<boolean>(false);
    const [resultFlag, setResultFlag] = useState<boolean>(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const oobCode = queryParams.get('oobCode') || '';
        if (oobCode) {
            let restoredEmail: string | null = null;
            // アクションコードが有効かどうかを確認
            checkActionCode(getAuth(), oobCode)
                .then((info) => {
                    // 復元されたメールアドレスを取得
                    restoredEmail = info.data.email ?? null;
                    // 古いメールアドレスに戻す
                    return applyActionCode(getAuth(), oobCode);
                })
                .then(() => {
                    if (restoredEmail) {
                        // パスワードリセットメールを送信
                        return sendPasswordResetEmail(getAuth(), restoredEmail);
                    } else {
                        throw new Error('No restored email available.');
                    }
                })
                .then(() => {
                    setResultFlag(true);
                })
                .catch((error) => {
                    console.log(error);
                    setResultFlag(false);
                })
                .finally(() => {
                    setInitCheck(true);
                });
        }
    }, []);

    if (initCheck) {
        return (
            <>
                <div id={isPcSite ? "formArea" : "formArea-Mobile"}>
                    <h1 className="title" id={isPcSite ? "PC" : "Mobile"}>{t('recoverEmail.title')}</h1>
                    {resultFlag ? (
                        <div id="succeeded">
                            <p>{t('recoverEmail.successMessage')}</p>
                            <p>{t('recoverEmail.successInstruction')}</p>
                        </div>
                    ) : (
                        <div id="failed">
                            <p>{t('recoverEmail.errorMessage')}</p>
                            <p>{t('recoverEmail.errorReason')}</p>
                        </div>
                    )}
                </div>
            </>
        );
    } else {
        return <></>;
    }
};

export default RecoverEmail;
